export default {
  userSexualPreferences: [],
  userDesires: []
};
